import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "text-m q-mb-none q-mx-auto" }
const _hoisted_2 = {
  key: 2,
  class: "main-error-comment full-width"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "q-ma-none text-l-b-3" }, "고객센터 : 070-4304-3397", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "q-ma-none text-2xs-3" }, " 평일 10:00 ~ 17:00 (주말, 공휴일 제외) ", -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "full-width row justify-center"
}

import { ref, toRefs } from 'vue';
import TodaysSouvenirScoreInfo from 'components/training/chat/ChatDetail/TodaysSouvenirScoreInfo.vue';

type propsType = {
  type?: string;
  trainingId?: string;
  title: string;
  comment?: string;
  singleInteraction?: boolean;
  button?: string;
  firstButton?: string;
  secondButton?: string;
  dialog: boolean;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'CenterDialog',
  props: {
    type: {},
    trainingId: {},
    title: {},
    comment: {},
    singleInteraction: { type: Boolean },
    button: {},
    firstButton: {},
    secondButton: {},
    dialog: { type: Boolean, default: false }
  },
  emits: [
  'onClickButton',
  'onClickFirstButton',
  'onClickSecondButton',
],
  setup(__props: any, { emit }) {

const props = __props;


const { dialog, type } = toRefs(props);



const fixedWidth = ref((breakpoint: string) => {
  return breakpoint !== 'xs';
});

function titleFont() {
  if (type?.value == 'help' || type?.value == 'session') return 'text-s-b';
  if (
    type?.value == 'result' ||
    type?.value == 'timeout' ||
    type?.value == 'continue'
  )
    return 'text-xl-b-3';
  return 'text-2xl-b';
}

function timeoutLayout() {
  if (type?.value === 'timeout') return 'column reverse';
  return '';
}

function onClickButton() {
  emit('onClickButton');
}

function onClickFirstButton() {
  emit('onClickFirstButton');
}

function onClickSecondButton() {
  emit('onClickSecondButton');
}

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: _unref(dialog),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(dialog) ? (dialog).value = $event : null)),
    class: _normalizeClass(["common-center-dialog", _unref(type) == 'main' ? 'main' : '']),
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, {
        class: _normalizeClass(["dialog-card", fixedWidth.value(_ctx.$q.screen.name) ? 'fixed-width' : 'relative-width'])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "row items-center text-center dialog-card-section" }, {
            default: _withCtx(() => [
              (_unref(type) === 'main' || _unref(type) == 'signInFailed')
                ? (_openBlock(), _createBlock(_component_q_icon, {
                    key: 0,
                    name: "error_outline",
                    color: "red",
                    size: "3.75rem",
                    class: "main-error-icon full-width text-center"
                  }))
                : _createCommentVNode("", true),
              (_unref(type) === 'session')
                ? (_openBlock(), _createBlock(_component_q_icon, {
                    key: 1,
                    name: "warning",
                    color: "red",
                    size: "3.75rem",
                    class: "main-error-icon full-width text-center"
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("p", {
                class: _normalizeClass(["dialog-title q-mb-none q-mx-auto full-width", titleFont()])
              }, _toDisplayString(_ctx.title), 3),
              _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.comment), 1),
              (_unref(type) === 'main')
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (
          (_unref(type) === 'help' || _unref(type) === 'instruction') && _ctx.trainingId == '9202'
        )
            ? (_openBlock(), _createBlock(_component_q_card_section, {
                key: 0,
                class: "q-pa-none"
              }, {
                default: _withCtx(() => [
                  _createVNode(TodaysSouvenirScoreInfo)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_q_card_actions, null, {
            default: _withCtx(() => [
              (_ctx.singleInteraction)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_q_btn, {
                      class: "text-m-b center-dialog-button",
                      label: _ctx.button,
                      onClick: onClickButton
                    }, null, 8, ["label"])
                  ]))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(["row full-width", timeoutLayout()])
                  }, [
                    _withDirectives(_createVNode(_component_q_btn, {
                      flat: "",
                      class: "col text-m-b dialog-button first-button",
                      label: _ctx.firstButton,
                      onClick: onClickFirstButton
                    }, null, 8, ["label"]), [
                      [_directive_close_popup]
                    ]),
                    _createVNode(_component_q_space, { class: "dialog-space" }),
                    _withDirectives(_createVNode(_component_q_btn, {
                      class: "col text-m-b dialog-button second-button",
                      label: _ctx.secondButton,
                      onClick: onClickSecondButton
                    }, null, 8, ["label"]), [
                      [_directive_close_popup]
                    ])
                  ], 2))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _: 1
  }, 8, ["modelValue", "class"]))
}
}

})